export const KIND_KEYS = [
  'office',
  'apt',
  'hosp',
  'school',
  'logi',
  'factory',
  'res',
  'ind',
] as const;
export type KindKey = (typeof KIND_KEYS)[number];

export const SOIL_KEYS = ['sand', 'clay', 'gravel', 'rock'] as const;
export type SoilKey = (typeof SOIL_KEYS)[number];

/** 現場の定義（`sites.json` の 1 件）。工事名・発注者・工程は架空。 */
export interface SiteDef {
  /** 連番（1〜）。現場 ID の下 3 けた。 */
  seq: number;
  kind: KindKey;
  name: string;
  client: string;
  /** 着工日 `YYYY-MM-DD`。 */
  start: string;
  /** 施工効率（架空の実績を作る係数）。 */
  perf: number;
  soil: SoilKey;
  pref: string;
  city: string;
  town: string;
  machiazaId: string;
  lgcode: number;
  lon: number;
  lat: number;
  /** 施工範囲の東西・南北（m）。 */
  w: number;
  d: number;
}

/** 現場の標高（`terrain.json` の 1 件）。標高は T.P.（m）。 */
export interface TerrainData {
  /** 施工範囲の格子のマス数（東西・南北）。 */
  nx: number;
  nz: number;
  /** 標高データの種類（DEM5A など）。 */
  src: string;
  /** 施工範囲の標高。点の数は (nx+1)×(nz+1)。北西から東へ、次に南へ並ぶ。 */
  E: Float32Array;
  /** 周辺地形の一辺の長さ（m）とマス数。 */
  cw: number;
  cn: number;
  /** 周辺地形の標高。点の数は (cn+1)²。 */
  C: Float32Array;
  emin: number;
  emax: number;
  emed: number;
}

export interface SiteInput {
  def: SiteDef;
  terrain: TerrainData;
}

/** 都道府県の代表地点（県庁の位置）。輪郭は使わないので持たない。 */
export interface PrefPoint {
  name: string;
  lon: number;
  lat: number;
}

/** 市区町村の代表地点（`municipalities.json` の 1 件）。 */
export interface Municipality {
  /** 都道府県の名前。 */
  pref: string;
  name: string;
  lon: number;
  lat: number;
}

/** 全国表示の線（県境の輪郭と高速道路）。点は [経度, 緯度]（度）。 */
export interface PrefShape {
  name: string;
  rings: [number, number][][];
  /** 本土側（点の最も多い輪郭）の範囲 [西, 南, 東, 北]。飛び地・離島を除いて移動先を決める。 */
  main: [number, number, number, number];
}
export interface MapLines {
  prefs: PrefShape[];
  roads: [number, number][][];
}
